// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-10e66d3e] .bj-page .el-form-item__label {\n  display: none;\n}\n[data-v-10e66d3e] .el-dialog__body {\n  padding-top: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
